import { render, staticRenderFns } from "./ConfigCategoryJagfx.vue?vue&type=template&id=42d3644e&"
import script from "./ConfigCategoryJagfx.vue?vue&type=script&lang=js&"
export * from "./ConfigCategoryJagfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports